import generateNgrams from './generateNgrams'

/**
 * Calculate N-gram similarity score
 */
const ngramSimilarity = (query, target) => {
  const queryNgrams = generateNgrams(query.toLowerCase())
  const targetNgrams = generateNgrams(target.toLowerCase())

  if (queryNgrams.length === 0 || targetNgrams.length === 0) return 0

  const querySet = new Set(queryNgrams)
  const targetSet = new Set(targetNgrams)

  const intersection = new Set([...querySet].filter(x => targetSet.has(x)))
  const union = new Set([...querySet, ...targetSet])

  return intersection.size / union.size
}

export default ngramSimilarity
